<div class="emoji" role="dialog" [attr.aria-label]="labels.title">
  <div class="emoji__search">
    <svg class="emoji__search-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"
      stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">
      <circle cx="11" cy="11" r="7"/><path d="m21 21-4.3-4.3"/>
    </svg>
    <input #search type="text" class="emoji__input" autocomplete="off" spellcheck="false" [attr.aria-label]="labels.search"
      [placeholder]="labels.search" (input)="onSearch($event)" (keydown)="onSearchKeydown($event)">
    <button *ngIf="query" type="button" class="emoji__clear" [attr.aria-label]="labels.close" (click)="clearSearch()">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
        aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6 6 18"/></svg>
    </button>
  </div>

  <div *ngIf="!query" class="emoji__tabs" role="tablist">
    <button *ngFor="let t of tabs" type="button" role="tab" class="emoji__tab" [class.emoji__tab--on]="t === tab"
      [attr.aria-selected]="t === tab" [attr.aria-label]="labelOf(t)" [title]="labelOf(t)" (click)="setTab(t)">
      <span class="emoji__glyph" aria-hidden="true">{{ icons[t] }}</span>
    </button>
  </div>

  <div class="emoji__title" aria-live="polite">{{ title }}</div>

  <div #grid class="emoji__grid" role="grid" [style.grid-template-columns]="'repeat(' + columns + ', minmax(0, 1fr))'">
    <button *ngFor="let e of visible; let i = index; trackBy: trackByChar" type="button" role="gridcell" class="emoji__cell"
      [attr.tabindex]="i === focusIndex ? 0 : -1" [attr.aria-label]="e.n" [title]="e.n"
      (keydown)="onGridKeydown($event, i)" (click)="choose(e)">
      <span class="emoji__glyph" aria-hidden="true">{{ e.c }}</span>
    </button>
    <p *ngIf="visible.length === 0" class="emoji__empty">{{ labels.empty }}</p>
  </div>
</div>
